import { useMemo } from 'react'

import useIsSupportChat from '~/features/chatbot/hooks/useIsSupportChat'
import useGetUser from '~/features/user/hooks/useGetUser'
import { store } from '~/store'

// referrer/currentPage are captured once, at layout level, by
// useEmbeddedChatContext (see ChatBotLayout) — this hook just reads them back
// out of the store and derives the `source` string DialogInput sends with
// every chat message.
const useChatSource = () => {
  const userId = store((state) => state.user.id)
  const { isSupportChat } = useIsSupportChat()
  const { data: userResponse, isLoading: isUserLoading } = useGetUser(
    isSupportChat && userId ? userId : '',
  )

  const referrer = store((state) => state.chatbot.referrer)
  const currentPage = store((state) => state.chatbot.currentPage)

  const userEmail = userResponse?.data?.email || ''

  const source = useMemo(() => {
    const sourceReferrer = referrer || ''
    const sourceUser = isSupportChat && userEmail ? `user: ${userEmail}` : ''
    const separator = sourceReferrer && sourceUser ? ', ' : ''

    return `${sourceReferrer}${separator}${sourceUser}`
  }, [isSupportChat, referrer, userEmail])

  return {
    isUserLoading,
    source,
    // Not consumed by this hook's own callers (v1) yet. v2 (useChatV2) already
    // sends context.currentPage on SESSION_INIT, but reads it directly via
    // store.getState().chatbot.currentPage rather than through this hook —
    // returned here in case v1's `source` string needs it too at some point.
    currentPage,
  }
}

export default useChatSource
